module.exports = __webpack_public_path__ + "static/media/intersection.f3bd3fe2.svg";